import { render, staticRenderFns } from "./KitCamera.vue?vue&type=template&id=14ac133c"
import script from "./KitCamera.vue?vue&type=script&lang=ts"
export * from "./KitCamera.vue?vue&type=script&lang=ts"
import style0 from "./KitCamera.vue?vue&type=style&index=0&id=14ac133c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports